module.exports = __webpack_public_path__ + "img/C2.2912e248.svg";